import React, { useState, useEffect } from 'react'
import { StatsContainer, SideBarMenuContainer } from './styles'
import { MainContent } from './MainContent'
import { SideBar } from './SideBar'
import { useWindowSize } from '../../hooks/useWindowSize'
import { useGlobal } from '../../contexts/GlobalContext'
import useToast from '../../hooks/useToast'

export const Stats = () => {
  const { invokeServer } = useGlobal();
  const windows = useWindowSize();
  const [isOpenSideMenu, setIsOpenSideMenu] = useState(false)
  const { showLoading, hideLoading } = useToast();
  const [tradeList, setTradeList] = useState();
  const [users, setUsers] = useState([]);
  const [isLoadMore, setIsLoadMore] = useState(false)
  const [paginationProps, setPaginationProps] = useState({
    page_size: 20,
    current_page: 1
  })
  const [filterValues, setFilterValues] = useState({
    eventType: 'trade',
    address: null
  })

  const handleChangeFilterValues = (name, val) => {
    setFilterValues({
      ...filterValues,
      [name]: val
    })
  }

  useEffect(() => {
    if (windows.width > 768) {
      setIsOpenSideMenu(true)
    } else {
      setIsOpenSideMenu(false)
    }
  }, [windows.width])

  const getTradeList = (page, page_size, newFetch = false) => {
    if (newFetch) showLoading('Loading...')
    else setIsLoadMore(true)

    let fetchUrl = filterValues?.eventType ? `/api/${filterValues?.eventType}?all=` : `/api/trade?all=`
    if (filterValues.address) fetchUrl = `${fetchUrl}&collectionAddress=${filterValues.address}`

    invokeServer('get', `${fetchUrl}&page=${page}&page_size=${page_size}`)
      .then(r => {
        if (r.data.result === 1) {
          if (newFetch) setTradeList(r.data.items)
          else setTradeList([...tradeList, ...r.data.items])
          setPaginationProps(r.data.pagination)
        }
      if (newFetch) hideLoading()
      else setIsLoadMore(false)
      })
      .catch(err => {
        console.log(`${err.message}`)
        if (newFetch) hideLoading()
        else setIsLoadMore(false)
      })
  }

  useEffect(() => {
    let ac = new AbortController();
    invokeServer('get', `/api/user?all=`)
      .then(r => {
        if (ac.signal.aborted === false) {
          if (r.data.result === 1) {
            setUsers(t => r.data.users);
          }
        }
      })
      .catch(err => {
        console.log(`${err.message}`)
      })
    return () => ac.abort();
  }, [])

  useEffect(() => {
    getTradeList(1, paginationProps.page_size, true)
  }, [filterValues])

  return (
    <StatsContainer isOpenSideMenu={isOpenSideMenu}>
      <SideBarMenuContainer style={isOpenSideMenu ? { width: '340px' } : { width: '64px' }}>
        <SideBar
          isOpenSideMenu={isOpenSideMenu}
          setIsOpenSideMenu={setIsOpenSideMenu}
          filterValues={filterValues}
          handleChangeFilterValues={handleChangeFilterValues}
        />
      </SideBarMenuContainer>
      <MainContent
        isOpenRightMenu={isOpenSideMenu}
        tradeList={tradeList}
        users={users}
        isLoadMore={isLoadMore}
        paginationProps={paginationProps}
        getTradeList={getTradeList}
      />
    </StatsContainer>
  )
}
